import { render, staticRenderFns } from "./IcoFaceFrown.vue?vue&type=template&id=6234d742"
import script from "./IcoFaceFrown.vue?vue&type=script&lang=js"
export * from "./IcoFaceFrown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports